<template>
  <modal
          @close="$emit('close')"
          class="client-comments-modal client-comments"
  >
    <template slot="header">
      <div v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['userNotes_Comments'])"></div>
        {{$t(`userNotes_Comments.localization_value.value`)}}
      </div>
    </template>
    <template slot="body">
      <div class="client-comments__content">
        <div class="client-comments__list" v-if="clientComments.getCount() > 0">
          <div class="client-comments__item"
               v-for="item in clientComments.getComments()"
               :key="item.id"
          >
            <div class="client-comments__item-head">
              <div class="client-comments__item-date">
                {{ item.created_at | moment('YYYY-MM-DD') }}
                <span class="client-comments__item-author" v-if="item.author">({{ item.author.email }})</span>              </div>
              <div v-if="isDeveloper"
                   v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                <div class="admin-edit" @click="editTranslate(['common_delete'])"></div>
                <LinkButton
                        :value="$t('common_delete.localization_value.value')"
                        :type="'delete'"
                        @click.native="removeComment(item.id)"
                />
              </div>
            </div>
            <div class="client-comments__item-category" v-if="item.category">
              {{ item.category }}
            </div>
            <div class="client-comments__item-txt">
              {{ item.comment }}
            </div>
          </div>
        </div>

        <div class="client-comments__row custom-row">
          <div class="client-comments__col custom-col"
               v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
            <div class="admin-edit" @click="editTranslate(['notes_category'])"></div>
            <DefaultSelect
                    :options="categoryOptions"
                    :label="$t('notes_category.localization_value.value')"
                    :optionsLabel="'name'"
                    :selected="selectedCategory"
                    v-bind:class="{'ui-no-valid': clientComments.validation.category}"
                    :error="clientComments.validation.category"
                    :errorTxt="$t(`${clientComments.validationTranslate.category}.localization_value.value`)"
                    @change="(val) => clientComments.setCategory(val ? val.name : '')"
            />
          </div>
          <div class="client-comments__col custom-col"
               v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
            <div class="admin-edit" @click="editTranslate(['common_comment',])"></div>
            <TextareaDefault
                    :label="$t('common_comment.localization_value.value')"
                    v-model="clientComments.data.txt"
                    :error="clientComments.validation.txt"
                    :errorTxt="$t(`${clientComments.validationTranslate.txt}.localization_value.value`)"
                    v-bind:class="{'ui-no-valid': clientComments.validation.txt}"
            />
          </div>
        </div>
      </div>
    </template>
    <template slot="footer">
      <div class="client-comments__btn"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate([
              'common_cancel',
              'common_save',
            ])"></div>
        <span
                class="site-link site-link--alt client-comments__btn-i"
                @click="$emit('close')"
        >
          {{ $t('common_cancel.localization_value.value') }}
        </span>

        <MainButton
                :value="$t('common_save.localization_value.value')"
                class="client-comments__btn-i"
                v-on:click.native="submitForm"
                v-bind:class="{'disabled-btn' : $store.getters.getNotesBtn}"
        />
      </div>
    </template>
  </modal>
</template>

<script>
  import Modal from '../../../commonModals/Modal.vue'
  import MainButton from '../../../UI/buttons/MainButton/MainButton.vue'
  import TextareaDefault from '../../../UI/textarea/TextareaDefault/TextareaDefault.vue'
  import LinkButton from "../../../UI/buttons/LinkButton/LinkButton";
  import DefaultSelect from "../../../UI/selectiones/DefaultSelect/DefaultSelect";

  export default {
    name: "ClientCommentsPopup",
    components: {
      Modal,
      MainButton,
      TextareaDefault,
      LinkButton,
      DefaultSelect,
    },

    props: {
      clientComments: Object,
    },

    computed: {
      categoryOptions() {
        return this.$store.getters.getNoteCategories.map(item => {
          return {name: item}
        })
      },

      selectedCategory() {
        return this.clientComments.getCategory() !== '' ? {name: this.clientComments.getCategory()} : ''
      },
    },

    created() {
      if(this.$store.getters.getNoteCategories.length === 0) {
        this.$store.dispatch('fetchNoteCategories')
      }
    },

    methods: {

      submitForm() {
        if(!this.clientComments.txtValidate()) return

        this.$store.dispatch('createNotes', this.clientComments.prepareSave()).then((response) => {

          switch (this.getResponseStatus(response)) {
              /**
               * Success
               */
            case this.$store.getters.GET_ERRORS.SUCCESS_CODE: {
              this.clientComments.addComment(this.getRespData(response))
              this.clientComments.setTxt('')
              this.clientComments.setCategory('')
              this.openNotify('success', 'common_notificationRecordCreated')
              break
            }
              /**
               * Validation Error
               */
            case this.$store.getters.GET_ERRORS.VALIDATION_ERROR_CODE: {
              let errors = response.response.data.errors;
              this.notifyErrorHelper(errors)
              break
            }
              /**
               * Undefined Error
               */
            default: {
              this.openNotify('error', 'common_notificationUndefinedError')
            }
          }
        })
      },

      removeComment(id) {
        let text = {
          title: 'common_deleteConfirm',
          txt: 'common_deleteItemAsk',
          yes: 'common_confirmDelete',
          no: 'common_confirmNo'
        }

        let confirm = () => {
          this.$store.dispatch('deleteNotes', id).then((response) => {
            switch (this.getResponseStatus(response)) {
              /**
               * Success
               */
              case this.$store.getters.GET_ERRORS.SUCCESS_CODE: {
                this.clientComments.removeComment(id)
                this.openNotify('success', 'common_notificationRecordDeleted')
                break
              }
              /**
               * Validation Error
               */
              case this.$store.getters.GET_ERRORS.VALIDATION_ERROR_CODE: {
                let errors = response.response.data.errors;
                this.notifyErrorHelper(errors)
                break
              }
              /**
               * Undefined Error
               */
              default: {
                this.openNotify('error', 'common_notificationUndefinedError')
              }
            }
          })

          this.$store.commit('setConfirmDeletePopup', false)
          return true
        }

        this.deleteFunc(text, confirm)
      },

    }
  }

</script>

<style lang="scss">
@import "../../../../scss/colors";

.client-comments{

  .modal-component__inner {
    max-width: 740px;
  }

  &__list{
    max-height: 400px;
    overflow-y: auto;
    margin-bottom: 30px;
  }

  &__item{
    padding: 12px 16px;
    margin-bottom: 10px;
    border: 1px solid $borderBrownOpacity04;
    border-radius: 5px;

    &:last-child{
      margin-bottom: 0;
    }
  }

  &__item-head{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;
  }

  &__item-date{
    font-size: 13px;
    line-height: 14px;
    color: $brown;
  }

  &__item-author{
    color: $black;
    font-weight: bold;
  }

  &__item-category{
    margin-bottom: 4px;
    font-size: 14px;
    line-height: 18px;
    color: $black;
    font-weight: bold;
  }

  &__item-txt{
    font-size: 14px;
    line-height: 18px;
    color: $black;
    white-space: pre-line;
    word-break: break-word;
  }

  &__btn{
    display: flex;
    align-items: center;
  }

  &__btn-i{
    margin-right: 30px;

    &:last-child{
      margin-right: 0;
    }
  }
}

</style>
